import * as simple from "../holidays";

/**
 * A Moment like date
 */
export interface MomentLikeDate {
  year: () => number;
  month: () => number;
  date: () => number;
}

export function getHolidaysByDate(date: MomentLikeDate) {
  return simple.getHolidaysByDate(date.year(), date.month() + 1, date.date());
}

export function isHoliday(date: MomentLikeDate) {
  return simple.isHoliday(date.year(), date.month() + 1, date.date());
}

export function isHolidayForState(
  date: MomentLikeDate,
  state: string,
): boolean {
  return simple.isHolidayForState(
    date.year(),
    date.month() + 1,
    date.date(),
    state,
  );
}

export function isHolidayForCountry(
  date: MomentLikeDate,
  country: simple.CountryName,
) {
  return simple.isHolidayForCountry(
    date.year(),
    date.month() + 1,
    date.date(),
    country,
  );
}
